/**
 * Formata CEP
 * 57036000 → "57036-000"
 */
export function formatCEP(cep: string): string {
  const digits = cep.replace(/\D/g, '')
  return digits.replace(/(\d{5})(\d{3})/, '$1-$2')
}

/**
 * Máscara de input: formata enquanto digita
 * "57036" → "57036"
 * "57036000" → "57036-000"
 */
export function maskCEP(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 8)
  return digits.replace(/(\d{5})(\d)/, '$1-$2')
}

/**
 * Remove máscara, retorna só dígitos
 * "57036-000" → "57036000"
 */
export function unmaskCEP(value: string): string {
  return value.replace(/\D/g, '')
}
